import styled from "styled-components";

export const Container = styled.div<{ active: boolean }>`
  padding: 30px 10px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 320px;
  gap: 10px;
  position: relative;
  padding-bottom: 75px;
  cursor: ${(props) => (props.active ? "pointer" : "auto")};
  .arrow {
    fill: black;
  }

  svg {
    fill: ${(props) => (props.active ? "#006f5e" : "gray")};
    font-size: 25px;
  }

  h3,
  p {
    color: ${(props) => (props.active ? "#000" : "gray")};
  }

  @media (max-width: 728px) {
    width: 100px;
    flex-direction: column;
  }
`;

export const TitleSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;

  @media (max-width: 728px) {
    display: none;
  }
`;

export const BoxInfo = styled.p`
  position: absolute;
  bottom: 15px;
  left: 40px;
`;

export const BoxInfoSpecialist = styled.p`
  position: absolute;
  bottom: 35px;
  left: 40px;
`;
